import { render, staticRenderFns } from "./addMemberBenefits.vue?vue&type=template&id=5c1ed188&scoped=true"
import script from "./addMemberBenefits.vue?vue&type=script&lang=js"
export * from "./addMemberBenefits.vue?vue&type=script&lang=js"
import style0 from "./addMemberBenefits.vue?vue&type=style&index=0&id=5c1ed188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1ed188",
  null
  
)

export default component.exports